import { getAuthToken } from "../../utils/Storage";

export function accessToken(): string | undefined {
    const t = getAuthToken("accessToken");
    return t != null && t !== "" ? t : undefined;
}